import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import classNames from 'classnames';

import { baseIconContainer } from './scss/Icons.module.scss';

function BaseIcon({ tag: Tag, className, ...props }) {
  return (
    <span className={classNames(baseIconContainer, className)}>
      <Tag {...props} />
    </span>
  );
}

BaseIcon.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

BaseIcon.defaultProps = {
  className: '',
  tag: SVG,
};

export default BaseIcon;
